(($, Drupal) => {
  Drupal.behaviors.kabClassSlider = {
    attach: (context) => {

      let $slideWrapper = $('.class-thumbnail-slider', context);
      if ($slideWrapper.length === 0) {
        return;
      }

      $(once('sliders', '.class-thumbnail-slider')).each(function () {

        var thumbnailSlider = new Swiper(".class-thumbnail-slider", {
          spaceBetween: 10,
          slidesPerView: 4,
          watchSlidesProgress: true,
          allowTouchMove: false,
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
          breakpoints: {
            960: {
              direction: 'vertical',
              slidesPerView: 3,
              spaceBetween: 0,
            },
          }
        });

        var mainSlider = new Swiper(".class-main-slider", {
          spaceBetween: 10,
          loop: true,
          navigation: false,
          effect: 'fade',
          thumbs: {
              swiper: thumbnailSlider,
          },
          effectFade: {
            crossFade: true,
          }
        });

        // Sync main slider to thumb slider when nav arrows are clicked.
        thumbnailSlider.on('slideChange', () => {
          mainSlider.slideTo(thumbnailSlider.realIndex);
        });

        // Allow keyboard users to select thumbnails.
        $(once('thumbnailPress', '.class-thumbnail-slider .swiper-slide')).each(function () {
          let $slide = $(this);
          $slide.on("keydown", (e) => {
            if (e.keyCode !== 13 && e.keyCode !== 32) return;
            var slideIndex = e.target.dataset.slideIndex;
            if (!slideIndex) return;
            thumbnailSlider.slideTo(slideIndex);
            mainSlider.slideTo(slideIndex);
          });
        });

      });

    }
  };
})(jQuery, Drupal);
